// packages block
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { FC, useContext, useRef, useState } from 'react';
// others block
import { PrimaryDots } from '../../assets/images';
import { AppContext, AuthContext } from '../../context';
import { ActionType } from '../../context/AppContextReducer';
import { UsersMenuProps } from '../../interfaceTypes';
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants';
import { UserActionType } from '../users/userReducer';

export const UsersMenu: FC<UsersMenuProps> = ({ currentUser, userDispatch, setSelectedUser }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const { isEdit, dispatch, isDeleteOpen } = useContext(AppContext)
  const { currentUser: appUser } = useContext(AuthContext)
  const { id } = currentUser || {}
  const userId = id || ""
  const { id: appUserId } = appUser || {}

  const handleClick = () => setOpen(!open);

  const handleClose = () => setOpen(false);

  const anchorRef = { [userId]: useRef<HTMLButtonElement>(null) };

  const handleEditModalOpen = () => {
    handleClose();
    dispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
    userDispatch({ type: UserActionType.SET_CURRENT_USER, currentUser: currentUser })
  }

  const handlePrintModalOpen = () => {
    handleClose();
    setSelectedUser(currentUser)
    dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isDeleteOpen })
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[userId]}
        id={`long-button-${userId}`}
        aria-controls={`long-menu-${userId}`}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${userId}`}
        anchorEl={anchorRef[userId].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <MenuItem onClick={handleEditModalOpen} disabled={userId === appUserId}>Edit</MenuItem>
        <MenuItem onClick={handlePrintModalOpen}>Print User Tasks</MenuItem>
      </Menu>
    </Box>
  );
};
